import React, { useContext } from 'react'
//import { navigate } from 'gatsby'
import { LanguageContext } from '../context'
//import { homePagePaths, translate } from '../translate'
import Navbar from './navbar'
import BurgerMenu from './burger-menu'
import SlideToggle from './client-search/slide-toggle'
//import Modal from './modal'


const Header = ({lang, path, location}) => {
  const { translationPaths, langcode } = useContext(LanguageContext)
  React.useEffect(() => {
  const menuWrap = document.querySelector(".bm-menu-wrap");
  if (menuWrap) {
    menuWrap.setAttribute("aria-hidden", true);
  }
}, []);


  return (
    <>
    <SlideToggle title="search" path={path} lang={lang} />
    <header className="global-header">
      <BurgerMenu
        right
        translationPaths={translationPaths}
        langcode={langcode}
        lang={lang}
        currentPath={path}
        location={location}
       />
      <Navbar
        translationPaths={translationPaths}
        langcode={langcode}
        lang={lang}
        currentPath={path}
        location={location}
       />
    </header>
    </>
  )
}

export default Header
